import { render, staticRenderFns } from "./FormSelection.vue?vue&type=template&id=369cb3a6&"
import script from "./FormSelection.vue?vue&type=script&setup=true&lang=js&"
export * from "./FormSelection.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports